<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
          <template slot-scope="scope" slot="menu">
            <el-button type="text"
                       size="small"
                       icon="el-icon-setting"
                       plain
                       v-if="permission.wxconfig_msgtemplate"
                       @click="getMsgTemplateList(scope.row)">消息模板配置
            </el-button>
            <el-dialog
              title="消息模板配置"
              v-if="showMsgTemplateFlag"
              :visible.sync="showMsgTemplateFlag"
              :close-on-click-modal="false"
              append-to-body="true"
              width="80%"
              :before-close="handleClose">
              <msgTemplate :configId='configId'></msgTemplate>
            </el-dialog>
          </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/wxconfig/wxconfig";
    import {mapGetters} from "vuex";
    import website from '@/config/website';
    import msgTemplate from './msgtemplate';
    export default {
      components: { msgTemplate },
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                configId: '', //配置id
                showMsgTemplateFlag: false, //消息模板配置
                option: {
                    height: 'auto',
                    calcHeight: 90,
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 6,
                    border: true,
                    index: true,
                    viewBtn: true,
                    selection: true,
                    dialogClickModal: false,
                    labelWidth: 130,
                    column: [
                               {
                                    label: "主键",
                                    prop: "id",
                                    editDisplay: false,
                                    addDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入主键",
                                        trigger: "change"
                                    }]
                                },
                                {
                                  label: "所属租户",
                                  prop: "tenantId",
                                  type: "tree",
                                  dicUrl: "/api/blade-system/tenant/select",
                                  props: {
                                    label: "tenantName",
                                    value: "tenantId"
                                  },
                                  hide: !website.tenantMode,
                                  addDisplay: website.tenantMode,
                                  editDisplay: website.tenantMode,
                                  viewDisplay: website.tenantMode,
                                  rules: [{
                                    required: true,
                                    message: "请输入所属租户",
                                    trigger: "click"
                                  }],
                                  span: 24,
                                },
                                {
                                    label: "类型",
                                    prop: 'type',
                                    type: 'select',
                                    search: true,
                                    dataType: "number",
                                    dicUrl:
                                     "/api/blade-system/dict/dictionary?code=wx_config_type",
                                    props: {
                                       label: "dictValue",
                                       value: "dictKey",
                                     },
                                  rules: [{
                                        required: true,
                                        message: "请选择类型",
                                        trigger: "change"
                      }]
                                },
                                                                                                                {
                                    label: "名称",
                                    prop: "name",
                                    rules: [{
                                        required: true,
                                        message: "请输入名称",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "APP_ID",
                                    prop: "appId",
                                    rules: [{
                                        required: true,
                                        message: "请输入app_id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "SECRET",
                                    prop: "secret",
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入secret",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "TOKEN值",
                                    prop: "token",
                                    hide: true,
                                    rules: [{
                                        required: false,
                                        message: "请输入接口配置里的Token值",
                                        trigger: "change"
                                    }]
                                },

                                                                                                                {
                                    label: "消息数据类型",
                                    prop: "msgDataFormat",
                                    hide: true,
                                    rules: [{
                                        required: false,
                                        message: "请输入接口消息数据类型",
                                        trigger: "change"
                                    }]
                                },
                                {
                                  label: "EncodingAESKey",
                                  prop: "aesKey",
                                  span:24,
                                  hide: true,
                                  rules: [{
                                    required: false,
                                    message: "请输入接口配置里的EncodingAESKey值",
                                    trigger: "change"
                                  }]
                                },
                                {
                                    label: "备注",
                                    prop: "remark",
                                    type:"textarea",
                                    span:24,
                                    rules: [{
                                        required: false,
                                        message: "请输入备注",
                                        trigger: "change"
                                    }]
                                },
                                                                        ]
                },
                data: []
            };
        },
    mounted(){

      this.$nextTick(() => {
                      this.option.height = this.bodyHeight - 343
              // this.reWrite = true;
              console.log(this.bodyHeight);
              setTimeout(()=>{
              console.log(this.$refs.crud)
              console.log(this.$refs.crud.$children[1].$children.length);
              let arrLength = this.$refs.crud.$children[1].$children.length;
              console.log(this.$refs.crud.$children[1].$children[arrLength-2].$el);
              this.$refs.crud.$children[1].$children[arrLength-2].$el.addEventListener("click", ()=>{
                // console.log(1212121)
                console.log("this.option.height=====>",this.option.height);
                    if(this.option.height == this.bodyHeight - 284){
                      this.option.height = this.bodyHeight - 343
                    }else{
                      this.option.height = this.bodyHeight - 284;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })
            });
    },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.wxconfig_add, false),
                    viewBtn: this.vaildData(this.permission.wxconfig_view, false),
                    delBtn: this.vaildData(this.permission.wxconfig_delete, false),
                    editBtn: this.vaildData(this.permission.wxconfig_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove(row);
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            getMsgTemplateList(row){
                this.showMsgTemplateFlag = true;
                this.configId = row.id;
              },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
